<div class="card-toolbar">
  <ul class="nav nav-tabs nav-bold nav-tabs-line">
    <li
      class="nav-item cursor-pointer"
      *ngFor="let statusKey of statusesKeys; let i = index"
      (click)="getDRPByStatus(statusKey)"
    >
      <a class="nav-link" [ngClass]="{ active: i === 0 }" data-toggle="tab">
        <span class="nav-text">{{ drpStatuses[statusKey] }} ({{ drpCounts[statusKey] }}) </span>
      </a>
    </li>
  </ul>
</div>

<div style="height: 90%; overflow-y: auto; width: 100%; overflow-x: auto">
  <ng-container *ngFor="let card of statusData[selectedKey]">
    <kt-drp-dashboard-card
      (refresh)="getDRPByStatus(selectedKey); getDrpCount()"
      [patient]="patient"
      [data]="card"
      [statusKey]="selectedKey"
      [medications]="medications"
    ></kt-drp-dashboard-card>
  </ng-container>
</div>
